import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../../../stateManager/store';
import moment from 'moment';
import { ReactComponent as DocumentSvg } from '../../../../../../assets/svg/sidemenu/home_help_docs.svg'
import { ReactComponent as ExampleSvg } from '../../../../../../assets/svg/sidemenu/home_help_exapmle.svg'
import { ReactComponent as MessageSvg } from '../../../../../../assets/svg/sidemenu/home_help_message.svg'
import { ReactComponent as FeedbackSvg } from '../../../../../../assets/svg/sidemenu/home_help_feedback.svg'
import { ReactComponent as Link } from '../../../../../../assets/svg/sidemenu/link.svg';
import { ReactComponent as Bulb } from '../../../../../../assets/svg/sidemenu/bulb.svg';
import { ReactComponent as Add } from '../../../../../../assets/svg/sidemenu/add.svg';
import { ReactComponent as Logo } from '../../../../../../assets/svg/a8_logo.svg'
import wavePattern from '../../../../../../assets/svg/sidemenu/onboarding_wave_pattern.svg';
import { useHistory } from 'react-router';
import { updateOnboarding } from '../../../../../../helpers/onboardingHelper';
import { clearOnboarding } from '../../../../../../stateManager/store/onboarding/action';
import App from '../../../../App';
import { Modal } from '../../../../../../helpers/commonUi';
import EditCreateTeam from '../../../../../organization/teams/editCreateTeam';
import { setCurrentOrganization } from '../../../../../../stateManager/store/orgs/actions';

type HomeQuickActionsProps = {
    getApps: (orgId: string) => void;
};
const docsHelp = [
    {
        title: "Documentations",
        content: "Our platform is made more accessible through our comprehensive guides, API reference, and code examples.",
        url: "https://docs.autonom8.com/studio/a8studio",
        Icon: DocumentSvg,
        bg: "#C9FFD580"
    },
    {
        title: "Examples",
        content: "Learn how to retrieve data with your apps and find inspiration along the way",
        url: "https://docs.autonom8.com/studio/guides/start-an-app",
        Icon: ExampleSvg,
        bg: "#CDE1FF"
    },
    {
        title: "Talk to an expert",
        content: "Need any help? Talk to us directly through chat.",
        url: "https://community.autonom8.com/",
        Icon: MessageSvg,
        bg: "#FFE7DB"
    },
    {
        title: "Send Feedback",
        content: "We're always looking to improve - let us know if you have ideas for missing features or enhancements.",
        url: "https://community.autonom8.com/",
        Icon: FeedbackSvg,
        bg: "#E0F9FF"
    }
]

const quickActions = [{ label: "Create App", value: "createApp" }, { label: "Create Team", value: "createTeam" }]

const HomeQuickActions: React.FC<HomeQuickActionsProps> = (props) => {

    const { getApps } = props;

    const { firstName, lastName = '' } = useSelector((state: AppState) => state.user.userDetails)
    const apps = useSelector((state: AppState) => state.apps.appsList)
    const userName = useSelector((state: AppState) => state.user.data.user.userName)
    const [appCreationVisible, setAppCreationVisible] = useState(false)
    const [teamCreationVisible, setTeamCreationVisible] = useState(false)
    const { selectedOrg, orgList } = useSelector((state: AppState) => state.org)

    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedOrg?.id == "" && orgList?.length === 1) {
            const orgDetail = orgList[0];
            dispatch(setCurrentOrganization({
                selectedOrg:
                {
                    id: orgDetail.id,
                    orgName: orgDetail.orgName,
                    owner: orgDetail.created_by
                }
            }))
        }
    }, [selectedOrg, orgList])

    const routeApp = (appData: any) => {
        if(appData.type === 'a8solo' || appData.type === 'a8chat' ){
            history.push(`/apps/list/${appData.appId}/journey/solo/list`)
        } else {
            history.push(`/apps/list/${appData.appId}/journey/assist/list`)
        } 
    }

    const selectOnboarding = async () => {
        const onboardingData = await updateOnboarding(userName, { stepIndex: 0, stageIndex: 0, skipTour: false, guideCompleted: false }, true);
        if (onboardingData && onboardingData.length) {
            dispatch(clearOnboarding(onboardingData[0].onboarding_status))
            history.push(`/select-onboarding`)
        }
    }

    const handleQuickAction = (action: { label: string, value: string }) => {
        if (action.value === 'createApp') {
            setAppCreationVisible(true)
        } else if (action.value === 'createTeam') {
            setTeamCreationVisible(true)
        }
    }

    return (
        <>
            <div className='home_quick_action' style={{ backgroundImage: `url(${wavePattern})`, backgroundRepeat: "no-repeat" }}>
                <div className='home_quick_action_tle'>
                    <h2>Welcome Back, <span>{firstName} {lastName}</span></h2>
                    <button onClick={selectOnboarding} className='retake_onboarding'><Bulb />Retake Learning Journey</button>
                </div>
                <div className='home_recent_apps_cont'>
                    <span className='home_quick_action_tle'>Recent Apps</span>
                    <div className='recent_apps'>
                        {
                            apps && apps.slice(0, 4).map((app: any) => {
                                return (
                                    <div className='recent_app' onClick={() => { routeApp(app) }}>
                                        <div className='recent_app_tle' title={app.name}>{app.name}</div>
                                        <div className='recent_app_card_cnt'>
                                            <span className='recent_app_card_createdat'>Created Date: {moment(app.created_at).format("DD-MM-YYYY")}</span>
                                            <span className={`recent_app_card_badge_${app.type.toLowerCase()} recent_app_card_badge`}>{app.type}</span>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='home_quick_actions_cont'>
                    <span className='home_quick_action_tle'>Quick Actions</span>
                    <div className='home_quick_actions'>
                        {
                            quickActions.map((action) => {
                                return (
                                    <div onClick={() => { handleQuickAction(action) }} className='home_quick_actions_card'>
                                        <Add />
                                        <span>{action.label}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <div className='home_quick_help'>
                    <span className='home_quick_action_tle'>Quick Help</span>
                    <div className='home_quick_help_docs'>
                        {
                            docsHelp.map((docs) => {
                                return (
                                    <div className='home_docs'>
                                        <div className='home_docs_tle'>
                                            <div className='home_docs_tle_icon' style={{ background: docs.bg }}>
                                                <docs.Icon></docs.Icon>
                                            </div>
                                            <span>
                                                <span>{docs.title}</span>
                                                <a href={docs.url} target='_blank'><span style={{ cursor: "pointer" }}><Link></Link></span></a>
                                            </span>
                                        </div>
                                        <span className='home_docs_content'>{docs.content}</span>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>

            <Modal
                title={'CREATE APP'}
                visible={appCreationVisible}
                className={'app_cre_mdl'}
                footer={{
                    enable: false,
                }}
                onCancel={() => {
                    setAppCreationVisible(false);
                }}
                unmountOnCancel={false}
            >
                {appCreationVisible ?
                    <App
                        getApps={() => { getApps(selectedOrg.id) }}
                        editable={false}
                        initialdata={{}}
                        onSubmit={(submit: any) => {
                            submit(setAppCreationVisible);
                        }}
                        okText={"CREATE"}
                        cancelText={"CANCEL"}
                        onCancel={() => {
                            setAppCreationVisible(false);
                        }}
                    /> :
                    <></>}
            </Modal>
            <EditCreateTeam selectedOrgId={selectedOrg.id} data={{}} visible={teamCreationVisible} setVisible={setTeamCreationVisible} setRefresh={() => { }} refresh={false} />
        </>
    );
};

export default HomeQuickActions;
